// extracted by mini-css-extract-plugin
export default {"styleChooserSection":"q2-z","dimensionLabel":"r2-z","styleChooserControlWrapper":"s2-z","styleChooserControl":"t2-z","disabled":"u2-z","giftCard":"v2-z","styleChooserText":"w2-z"};